import { Component, OnInit } from '@angular/core';
import { BaseInlineUpdateComponent, InlineContainerService } from 'yt-ng-framework';
import { RadnoMestoPoslovi } from './radno-mesto-poslovi';


@Component({
  selector: 'yt-radno-mesto-poslovi-stavka-inline-update',
  templateUrl: './radno-mesto-poslovi-stavka-inline-update.component.html'
})
export class RadnoMestoPosloviStavkaInlineUpdateComponent 
extends BaseInlineUpdateComponent<RadnoMestoPoslovi> {

  constructor(
    protected inlineContainerService: InlineContainerService<RadnoMestoPoslovi>
  ) { 
    super(inlineContainerService)
  }
}
